import { ICountryGuiModel } from "../model/ICountryGuiModel";
import CountryService from "../service/CountryService";
import { ICountryModel } from "../service/model/ICountryModel";
import { BusinessLogicResult } from "./BusinessLogicResult";

export default class CountryBusinessLogic {

    public async getCountries(
        organizationId: string,
    ): Promise<BusinessLogicResult<ICountryGuiModel[]>> {


        const service = new CountryService();
        const result = await service.getCountries(organizationId);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: ICountryModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    isoTwoLetters: e.isoTwoLetters,
                    isoThreeLetters: e.isoThreeLetters,
                    nameEnglish: e.nameEnglish,
                    countryCode: e.countryCode,
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
}